import React from 'react';
import {render} from 'react-dom';

import ProductOverview from './components/ProductOverview';

const productOverview = document.getElementById('product-overview');
if (productOverview != null) {
    const props = {};

    // Parse dataset to valid props
    for (const key in productOverview.dataset) {
        props[key] = productOverview.dataset[key];

        // Try to parse string to literal
        // Will parse: array, boolean, null, number, object and string
        try {
            props[key] = JSON.parse(props[key]);
        } catch (e) {} // eslint-disable-line no-empty
    }

    render(
        <ProductOverview
            {...props}
        />,
        productOverview
    );
}
